import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Planner from "./pages/Planner";
import InviteCodes from "./pages/InviteCodes";
import Students from "./pages/Students";
import ExplorePage from "./pages/ExplorePage";
import Schools from "./pages/Schools";
import { useSelector } from "react-redux";

import NavBar from "./shared/components/NavBar/NavBar";
import SideBar from "./shared/components/SideBar/SideBar";
import {
  startTokenVerification,
  stopTokenVerification,
} from "./shared/utils/tokenVerification";
import { getToken } from "./store/auth/selectors";

function Layout() {
  const token = useSelector(getToken);
  const location = useLocation();

  useEffect(() => {
    // Start token verification if token exists
    if (token) {
      startTokenVerification();
    }

    // Cleanup on unmount
    return () => {
      stopTokenVerification();
    };
  }, [token]); // Re-run when token changes
  return (
    <div style={{ height: "100%" }}>
      <div className="app">
        <NavBar />
        <div className="mainContent">
          <div className="sidebar">
            <SideBar />
          </div>
          {/* <div className="content" style={{ width: "100%", height: "100%" }}> */}
          {/* Mount all components but control visibility with CSS */}
          <div
            style={{
              display: location.pathname === "/planner" ? "block" : "none",
              width: "calc(100% - 220px)",
            }}
          >
            <Planner />
          </div>
          <div
            style={{
              display: location.pathname === "/invite-codes" ? "block" : "none",
              width: "calc(100% - 220px)",
            }}
          >
            <InviteCodes />
          </div>
          <div
            style={{
              display: location.pathname === "/students" ? "block" : "none",
              width: "calc(100% - 220px)",
            }}
          >
            <Students />
          </div>
          <div
            style={{
              display: location.pathname === "/explore" ? "block" : "none",
              width: "calc(100% - 220px)",
            }}
          >
            <ExplorePage />
          </div>
          <div
            style={{
              display: location.pathname === "/schools" ? "block" : "none",
              width: "calc(100% - 220px)",
            }}
          >
            <Schools />
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export default Layout;
